/** Layer 2: queryOptions factory for the public countries list. */
import { queryOptions } from "@tanstack/react-query";
import { fetchCountries } from "./countriesApi";
import { countriesKeys } from "./queryKeys";

/** Countries rarely change — cache indefinitely for the session. */
export const countriesQueryOptions = () =>
  queryOptions({
    queryKey: countriesKeys.list(),
    queryFn: fetchCountries,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
  });
